import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cb53338"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "176",
  height: "201",
  viewBox: "0 0 176 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = { opacity: "1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        id: "vShape",
        d: "M138.614 194.839H37.386L81.4809 47.8426C81.9033 46.4423 82.7654 45.2153 83.9395 44.3431C85.1136 43.4709 86.5373 43 87.9999 43C89.4626 43 90.8863 43.4709 92.0604 44.3431C93.2345 45.2153 94.0966 46.4423 94.519 47.8426L138.614 194.839Z",
        stroke: "white",
        style: _normalizeStyle(_ctx.vShape),
        "stroke-width": "10",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 4),
      _createElementVNode("path", {
        id: "lines",
        d: "M67.7544 93.6143H108.246",
        stroke: "white",
        "stroke-width": "10",
        "stroke-linecap": "round",
        style: _normalizeStyle(_ctx.lines),
        "stroke-linejoin": "round"
      }, null, 4),
      _createElementVNode("path", {
        id: "lines",
        d: "M61.6804 113.859H114.319",
        stroke: "white",
        "stroke-width": "10",
        "stroke-linecap": "round",
        style: _normalizeStyle(_ctx.lines),
        "stroke-linejoin": "round"
      }, null, 4),
      _createElementVNode("path", {
        id: "lines",
        d: "M52.5701 144.228H123.43",
        stroke: "white",
        "stroke-width": "10",
        "stroke-linecap": "round",
        style: _normalizeStyle(_ctx.lines),
        "stroke-linejoin": "round"
      }, null, 4),
      _createElementVNode("path", {
        id: "lines",
        d: "M46.4963 164.473H129.503",
        stroke: "white",
        "stroke-width": "10",
        "stroke-linecap": "round",
        style: _normalizeStyle(_ctx.lines),
        "stroke-linejoin": "round"
      }, null, 4),
      _createElementVNode("path", {
        id: "baseLine",
        d: "M22.2017 194.842H153.798",
        stroke: "white",
        "stroke-width": "10",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        style: _normalizeStyle(_ctx.baseLine)
      }, null, 4)
    ])
  ]))
}